import { render, staticRenderFns } from "./peiche.vue?vue&type=template&id=e8174568&scoped=true&"
import script from "./peiche.vue?vue&type=script&lang=js&"
export * from "./peiche.vue?vue&type=script&lang=js&"
import style0 from "./peiche.vue?vue&type=style&index=0&id=e8174568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8174568",
  null
  
)

export default component.exports